import Image from "next/image"
import styles from "./tnpsc-group-gs-mains-test-series-2023.module.css";
import Webbanner from "../../assets/images/Tnpsc/Gr-I-Mains-Test---Web-Banner---W-1903px-X-H-438px.jpg";
import Mobbanner from "../../assets/images/Tnpsc/Gr-I-Mains-Test---Mobile-Banner---W-903px-X-H-1208px.jpg";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import dynamic from "next/dynamic";
const Interest = dynamic(()=>import("../../components/might-be-interest"));
import Head from "next/head";
import Link from "next/link";
const TNPSC_Group_I_GS_Mains_Test_Series_2023 = () => {

    const feestructure3 =[

        {center: "AnnaNagar", mode: "Batch I (Offline Only)", start: "19th June 2025",
            fee: (<><div>₹42,000 (SIA Old Students)</div> <div>₹46,000 (New Students)</div> </>),
            cont3:(<Link href="https://www.shankariasacademy.com/pdf/Tnpsc-Grp-I-Mains-TestSeries-2025/TNPSC-GroupI-Mains-Test Series-2025-AnnaNagar.pdf" target="_blank" className={`${styles.paybill}`}> Click here</Link>),
            pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=TNPSC" target="_blank" rel="noopener noreferrer">
                <button className={`${styles.normalbutton1} btn btn-danger`}>
                Pay Now
                </button>
            </a>)
        },

         {center: "Adyar", mode: "Batch I (Offline Only)", start: "01st July 2025",
            fee: (<><div>₹42,000 (SIA Old Students)</div> <div>₹46,000 (New Students)</div> </>),
            cont3:(<Link href="https://www.shankariasacademy.com/pdf/Tnpsc-Grp-I-Mains-TestSeries-2025/TNPSC-GroupI-Mains-Test Series-2025-Adyar.pdf" target="_blank" className={`${styles.paybill}`}> Click here</Link>),
            pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=Adyar&coursetype=TNPSC" target="_blank" rel="noopener noreferrer">
                <button className={`${styles.normalbutton1} btn btn-danger`}>
                Pay Now
                </button>
            </a>)
        },

        {center:"Trichy",mode:"Batch I (Offline Only)",start:"25th June 2025", 
            fee: ( <> <div>₹42,000 ( SIA Old Students)</div>  <div>₹46,000 (New Students)</div></>), 
          cont3: (<Link href="https://www.shankariasacademy.com/pdf/Tnpsc-Grp-I-Mains-TestSeries-2025/TNPSC-GroupI-Mains-Test Series-2025-Trichy.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link>),
            pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=Trichy&coursetype=TNPSC" target="_blank" rel="noopener noreferrer">
                <button className={`${styles.normalbutton1} btn btn-danger`}>
                Pay Now
                </button>
            </a>)
        },

         {center:"Thiruvarur",mode:"Batch I (Offline Only)",start:"25th June 2025", 
            fee: ( <> <div>₹42,000 ( SIA Old Students)</div>  <div>₹46,000 (New Students)</div></>), 
          cont3: (<Link href="https://www.shankariasacademy.com/pdf/Tnpsc-Grp-I-Mains-TestSeries-2025/TNPSC-GroupI-Mains-Test Series-2025-Thiruvarur.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link>),
            pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=Thiruvarur&coursetype=TNPSC" target="_blank" rel="noopener noreferrer">
                <button className={`${styles.normalbutton1} btn btn-danger`}>
                Pay Now
                </button>
            </a>)
        },

        {center:"Madurai",mode:"Batch I (Offline Only)",start:"26th June 2025", 
            fee: ( <> <div>₹42,000 ( SIA Old Students)</div>  <div>₹46,000 (New Students)</div></>), 
          cont3: (<Link href="https://www.shankariasacademy.com/pdf/Tnpsc-Grp-I-Mains-TestSeries-2025/TNPSC-GroupI-Mains-Test Series-2025-Madurai.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link>),
            pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=Madurai&coursetype=TNPSC" target="_blank" rel="noopener noreferrer">
                <button className={`${styles.normalbutton1} btn btn-danger`}>
                Pay Now
                </button>
            </a>)
        },
        
        {center:"Salem",mode:"Batch I (Offline Only)",start:"26th June 2025", 
            fee: ( <> <div>₹42,000 ( SIA Old Students)</div>  <div>₹46,000 (New Students)</div></>), 
          cont3: (<Link href="https://www.shankariasacademy.com/pdf/Tnpsc-Grp-I-Mains-TestSeries-2025/TNPSC-GroupI-Mains-Test Series-2025-Salem.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link>),
            pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=Salem&coursetype=TNPSC" target="_blank" rel="noopener noreferrer">
                <button className={`${styles.normalbutton1} btn btn-danger`}>
                Pay Now
                </button>
            </a>)
        },

         {center:"Coimbatore",mode:"Batch I (Offline Only)",start:"26th June 2025", 
            fee: ( <> <div>₹42,000 ( SIA Old Students)</div>  <div>₹46,000 (New Students)</div></>), 
          cont3: (<Link href="https://www.shankariasacademy.com/pdf/Tnpsc-Grp-I-Mains-TestSeries-2025/TNPSC-GroupI-Mains-Test Series-2025-Coimbatore.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link>),
            pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=Covai&coursetype=TNPSC" target="_blank" rel="noopener noreferrer">
                <button className={`${styles.normalbutton1} btn btn-danger`}>
                Pay Now
                </button>
            </a>)
        },

        {center:"Namakkal",mode:"Batch I (Offline Only)",start:"27th June 2025", 
            fee: ( <> <div>₹42,000 ( SIA Old Students)</div>  <div>₹46,000 (New Students)</div></>), 
          cont3: (<Link href="https://www.shankariasacademy.com/pdf/Tnpsc-Grp-I-Mains-TestSeries-2025/TNPSC-GroupI-Mains-Test Series-2025-Namakkal.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link>),
            pay: (<a href="https://admissionsv1.shankariasacademy.com/?center=Namakkal&coursetype=TNPSC" target="_blank" rel="noopener noreferrer">
                <button className={`${styles.normalbutton1} btn btn-danger`}>
                Pay Now
                </button>
            </a>)
        },
    ]
    return (
        <>

        <Head>
            <meta charset="UTF-8" />
            
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>TNPSC Group I GS Mains Test Series 2025</title>
            <meta name="title" content="TNPSC Group I GS Mains Test Series 2025" />
            <meta name="description" content="Join Shankar IAS Academy’s TNPSC Group I GS Mains Test Series 2025. Improve your answer writing skills with expert guidance & detailed evaluations." />
            <link rel="canonical" href="https://www.shankariasacademy.com/tnpsc-group-i-mains-test-series/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="TNPSC Group I GS Mains Test Series 2025" />
            <meta property="og:description" content="Join Shankar IAS Academy’s TNPSC Group I GS Mains Test Series 2025. Improve your answer writing skills with expert guidance & detailed evaluations." />
            <meta property="og:url" content="https://www.shankariasacademy.com/tnpsc-group-i-mains-test-series/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
        </Head>

    <Navbar title="tnpsc" />

    <div className="container">
        <div className="row">
            <div className="col pt-3 pt-md-5">
                <h1 className={`${styles.pagemaintitle}`}>TNPSC Group I GS Mains Test Series 2025</h1>
            </div>
        </div>

        <div className="row d-none  d-md-block">
            <div className="col pt-2 mb-3">
                <Image src={Webbanner} alt="tnpsc-group-II-mains-test-series banner" title="TNPSC Group II/II-A Mains 2022 New Test Series" className="img-fluid w-100" />
            </div>
        </div>

        <div className="row  d-block d-md-none">
            <div className="col pt-2 mb-3">
                <Image src={Mobbanner} alt="tnpsc-group-II-mains-test-series banner" title="TNPSC Group II/II-A Mains 2022 New Test Series" className="img-fluid w-100" />
            </div>
        </div> 
    </div>
        
    <section  id="courseandfees">
        <div className="container pt-xl-4" >
            <div className="row">
                    <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#7f0801" }}>Center</div>
                    <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#7f0801" }}>Mode</div>
                    <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#7f0801" }}>Starts on</div>
                    <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#7f0801" }}>Fee</div>
                    <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#7f0801" }}>Schedule</div>
                    <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#7f0801" }}>Payment</div>
                    <hr/>
            </div>
                    
            {feestructure3.map((item,index)=>(
                <div className={`${styles.facultyborder3} row`}>
                      <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Center</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-0`}>{item.center}</div>
                      <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Mode</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-0  pb-md-3`}>{item.mode}</div>
                      <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Starts on</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-0`}>{item.start}</div>
                      <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Fee</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-0`}>{item.fee}</div>
                      <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Schedule</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-0`}>{item.cont3}</div>
                      <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Payment</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-2 text-center pt-2 pt-md-0`}>
                              {item.pay}
                            </div>
                            <hr/>
                </div>
                    ))} 
                </div>
	</section> 

    <Interest />
    <Footer />

        </>
    )
}

export default TNPSC_Group_I_GS_Mains_Test_Series_2023




























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































